import Link from 'next/link';
import Image from 'next/image';

export default function InterestSection() {
  return (
    <section className="int">
      <Link href="/kontakt" aria-label="Přejít na kontakt">
        <div className="int-content">
          <h2>
            Každý den bez funkčního webu<br />
            vás stojí zákazníky. Napište mi!
          </h2>
          <span className="int-arrow" aria-hidden="true">
            <Image src="/images/icons/icons8-right-arrow-64.png" alt="" width={64} height={64} />
          </span>
        </div>
      </Link>
    </section>
  );
}
